import type { IMicroCreditTypeData } from '~/components/widget/microcredits/list/types'

export const navItems = [
  { name: 'common.about_company', link: '#about' },
  { name: 'common.credits', link: 'credits' },
  { name: 'common.deposits', link: 'deposits' },
  { name: 'common.bank_cards', link: 'cards' },
  { name: 'common.vacancies', link: 'vacancies' },
  { name: 'common.news', link: 'news' },
  { name: 'common.exchange_rates', link: 'rates' },
  { name: 'common.branches', link: 'branches' },
  { name: 'common.atms', link: 'atms' },
  { name: 'common.money_transfers', link: 'money-transfers' }
]

export const microcreditsTypes: IMicroCreditTypeData[] = [
  {
    title: 'common.microfinance_companies',
    singularTitle: 'common.microfinance_company',
    url: '/microcredits/mfk',
    icon: 'mfk',
    type: 'mfk'
  },
  {
    title: 'common.microcredit_companies',
    singularTitle: 'common.microcredit_company',
    url: '/microcredits/mkk',
    icon: 'mkk',
    type: 'mkk'
  },
  {
    title: 'common.microcredit_agencies',
    singularTitle: 'common.microcredit_agency',
    url: '/microcredits/mka',
    icon: 'mka',
    type: 'mka'
  }
]
